import React from 'react';

const CancelBtn = props => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 2.5L2.5 13.5" stroke="#219737" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 2.5L13.5 13.5" stroke="#219737" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default CancelBtn;
